import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, Zap } from "lucide-react";
import ZigzagDivider from "@/components/ZigzagDivider";

const Hero = () => (
  <section className="hero-gradient relative overflow-hidden" data-testid="hero-section">
    <motion.div
      animate={{ opacity: [0.06, 0.14, 0.06] }}
      transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
      className="pointer-events-none absolute -right-10 top-24 hidden md:block"
      aria-hidden="true"
    >
      <Zap className="h-80 w-80 text-copper" strokeWidth={0.75} fill="currentColor" fillOpacity={0.06} />
    </motion.div>
    <p
      className="absolute right-4 top-1/2 hidden -translate-y-1/2 text-[10px] uppercase tracking-[0.4em] text-white/40 lg:block"
      style={{ writingMode: "vertical-rl" }}
      aria-hidden="true"
    >
      Albany WA — Great Southern
    </p>
    <div className="relative mx-auto max-w-7xl px-5 pb-32 pt-32 md:px-10 md:pb-48 md:pt-44">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.15, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="mb-12"
        data-testid="hero-logo"
      >
        <img
          src="/logo-cutout.png"
          alt="Exchange Electrical"
          className="w-[21rem] max-w-full sm:w-[30rem] md:w-[42rem] lg:w-[46rem]"
        />
      </motion.div>
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.55, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-xl text-lg leading-relaxed text-white/70 md:text-xl"
        data-testid="hero-subcopy"
      >
        Albany's local electrician for kitchen and bathroom renovations, new builds,
        switchboard upgrades and everything in between — 15+ years of licensed work
        in the electrical industry.
      </motion.p>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.7, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="mt-12 flex flex-wrap items-center gap-4"
      >
        <Link
          to="/quote"
          data-testid="hero-quote-button"
          className="group flex items-center gap-2 bg-copper px-8 py-4 text-sm font-bold uppercase tracking-[0.15em] text-ink transition-colors hover:bg-white md:py-5 md:text-base"
        >
          Request a Quote
          <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 md:h-5 md:w-5" strokeWidth={2} />
        </Link>
        <button
          onClick={() => window.__lenis?.scrollTo("#services", { offset: -60 })}
          data-testid="hero-services-button"
          className="border-2 border-white/40 px-8 py-4 text-sm uppercase tracking-[0.15em] text-white transition-colors hover:border-copper hover:text-copper md:py-5 md:text-base"
        >
          Our Services
        </button>
      </motion.div>
    </div>
    <ZigzagDivider fill="#142a34" className="relative" />
  </section>
);

export default Hero;
